import * as React from "react";
const SvgIcDesktop = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M14 18H23V1H1V18H10V20H6V23H18V20H14V18ZM20 13H4V4H20V13Z" fill="currentColor" /></svg>;
export default SvgIcDesktop;